<card-container
  class="card-container"
  #cardContainer
  tabindex="0"
  (contextmenu)="openMenu($event)"
  [matTooltip]="archive.name"
  [matTooltipDisabled]="!archiveNameTruncated">
  <div main class="content" [ngClass]="archive.resource_type">
    <!-- #region Thumbnail -->
    @switch (archive.resource_type) {
      @case (RESOURCE_TYPE.SESSION) {
        <thumbnail
          [src]="archive.thumbnail_url"
          [fallbackIcon]="'ficon-app-camcorder'"
          [duration]="archive.duration"
          class="media-thumbnail"
          >
        </thumbnail>
      }
      <!-- endregion -->
      @case (RESOURCE_TYPE.GROUP) {
        <div class="folder-icon">
          <i class="ficon-folder-outline"></i>
        </div>
      }
      @case (RESOURCE_TYPE.ACTIVITY) {
        <div class="activity-icon">
          <i class="ficon-assignment"></i>
        </div>
      }
    }
  </div>
  <div
    info-first-line
    detectTextTruncation
    (truncatedChange)="handleTruncatedChange($event)"
    >
    {{ archive.name }}
    @if (!archive.name?.length) {
      <span>&#8212;</span>
    }
  </div>
  <div info-second-line class="owner-line">
    @if (!archive.presenters?.length) {
      <span>{{ archive.owner_name }}</span>
    }
    @if (archive.presenters?.length) {
      <ellipsis-with-count class="ellipsis" [nameList]="getNameList(archive)" ></ellipsis-with-count>
    }
  </div>
  <div info-third-line>{{ archive.archived_at | formatDate }}</div>
  <div info-third-line-action-btns>
    <button
      class="menu-btn btn-none"
      [attr.data-cy]="'archive-menu-' + archive.resource_type"
      [attr.aria-label]="'session-list-item_view-options' | translate"
      (click)="openMenu($event)">
      <i class="ficon-app-dots-vertical"></i>
    </button>
    <menu>
      <archive-menu [archived]="archive"></archive-menu>
    </menu>
  </div>
</card-container>
